/* @flow */
/* eslint-disable babel/no-invalid-this */
import Dispatch from "nexia_mobile/flux_like/dispatch";
import type { ActivateLockFeature } from "./types";

export default function ActivateLock(feature: ActivateLockFeature) {
  let activateAction = feature.actions.activate;

  this.activate = () => {
    const promiseWithAbort = this.executeDeviceAction(activateAction, {});

    promiseWithAbort.then(() => {
      Dispatch("DEMO_MODE_EVENT", this, "Activated");
    });

    return promiseWithAbort;
  };

  return { isActivatable: feature.is_activatable };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/activate_lock.js